module.exports = {
  defaultTitle: '#GPO autósiskola - sofőriskola - Székelyudvarhely',
  logo: 'https://gpoauto.ro/',
  author: 'GPO',
  url: 'https://gpoauto.ro',
  legalName: 'Scoala de conducatori auto - Pálfi Gáspár Csaba - Autósiskola / Cat.B, BE / AS Nr. 000443',
  defaultDescription: 'AUTÓSISKOLA, SOFŐRISKOLA, JOGOSÍTVÁNY, JOGSI  - Székelyudvarhely - #GPO - Pálfi Gáspár Csaba',
  keywords:'Keywords: autósiskola,sofőriskola, jogsi, jogosítvány,Udvarhely, Székelyudvarhely, autósiskolák, b Cod96 BE  kategóriás jogosítvány, kresz tanfolyam, jogosítvány kategóriák, oktatás, hargita megye, jogsi, iskolák, tanfolyam, járművezető, jogositvany, utánfutó, remorca',
  socialLinks: {
    instagram: 'https://instagram.com/hr10gpo',
    facebook: 'https://www.facebook.com/hr10gpo/',
    google: 'https://www.google.com/maps/place/P%C3%A1lfi+G%C3%A1sp%C3%A1r+Csaba+aut%C3%B3siskola+-+%23GPO/@46.3040777,25.292535,15.56z/data=!4m5!3m4!1s0x0:0xf392ef5da1cde143!8m2!3d46.3031443!4d25.2943012?fbclid=IwAR3SISFe73IcC_rDLUstQrUQr_CEO4J6MzTMJrb6S38pLrh16M44lH20fCw',
  },
  googleAnalyticsID: 'G-MESRNJJ1QV',
  social: {
    facebook: 'hr10gpo',
    instagram: '@hr10gpo',
  },
  address: {
    city: 'Odorheiu Secuiesc',
    region: 'Hargita',
    country: 'Romania',
    zipCode: '535600',
    
  },
  contact: {
    email: 'hr10gpo@gmail.com',
    phone: '0040741093493',
  },
  foundingDate: '2016',
};
